import { render, staticRenderFns } from "./PersonnelRecordsSplitScreen.vue?vue&type=template&id=618e9402&scoped=true"
import script from "./PersonnelRecordsSplitScreen.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordsSplitScreen.vue?vue&type=script&lang=js"
import style0 from "./PersonnelRecordsSplitScreen.vue?vue&type=style&index=0&id=618e9402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e9402",
  null
  
)

export default component.exports